// Order violation error codes
export const PRODUCT_DISABLED_CODE = 10000;
export const SECTION_PRODUCT_DISABLED_CODE = 20000;
export const OUT_OF_STOCK_CODE = 30000;
export const INSUFFICIENT_STOCK_CODE = 40000;
export const NO_ITEMS_CODE = 50000;
export const INACTIVE_SECTION_CODE = 55500;
export const FULFILMENT_TIME_UNAVAILABLE = 60000;
export const NO_USER_OR_EMAIL = 70000;
export const CLOSED_TAB_CODE = 90000;
